import { userDomain } from '@user';

export const useShortGenderMap = () => {
  return {
    [userDomain.Gender.Male]: 'Муж.',
    [userDomain.Gender.Female]: 'Жен.',
    [userDomain.Gender.Any]: 'Любой',
  };
};
